import { useMemo } from 'react';

import { TECHNOS_PREMIUM } from 'common/configuration/constants';

const useTechnoPremium = (experiences: string[]) =>
  useMemo(() => {
    const experience = experiences.find(
      experience => TECHNOS_PREMIUM?.[experience]?.personalizedBooking
    );

    return experience && TECHNOS_PREMIUM?.[experience]
      ? { ...TECHNOS_PREMIUM[experience], name: experience }
      : undefined;
  }, [experiences]);

export default useTechnoPremium;
